export default {"src":"/_next/static/media/logo.750d0ab0.svg","height":36,"width":31};